import {
  useAppSelector,
  setEventType,
  useAppDispatch,
  setCompetition,
  setExchEvent,
  SportNameByIdMap,
  SportSlugById,
  setLoading,
  setIsLoginModalOpen,
} from "@hypexone/uicore";
import ReportingClient from "@hypexone/uicore/lib/cjs/src/client/reporting/reporting_client";
import { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { errorHandler } from "../../../../App.utils";
import { getEnvUrlsMap } from "../../../../api/api-services/environment-url/environment-url";
interface ExpDTO {
  eventId: string;
  sportId: string;
  competitionId: string;
  eventName: string;
  competitionName: string;
  exposure: number;
}

interface AllOpenBetsDTO {
  setShowOpenBets: Function;
  //   toggleAccountOptionsSidebar: Function;
}

const AllOpenBets: React.FC<AllOpenBetsDTO> = (props) => {
  const { setShowOpenBets } = props;
  const dispatch = useAppDispatch();
  const navigate = useNavigate();
  const [expData, setExpData] = useState<ExpDTO[]>();
  const [totalExp, setTotalExp] = useState<number>();
  const { langData } = useAppSelector((state) => state.cms);
  const { balanceSummary, loading, loggedIn } = useAppSelector((state) => state.auth);

  const exposure = balanceSummary?.exposure
    ? balanceSummary?.exposure?.toFixed(2)
    : "0.00";

  const handleEventChange = (event: ExpDTO) => {
    if (!loggedIn) {
      dispatch(setIsLoginModalOpen(true));
      return;
    }
    const competitionSlug = event.competitionName
      ? event.competitionName
          .toLocaleLowerCase()
          .replace(/[^a-z0-9]/g, " ")
          .replace(/ +/g, " ")
          .trim()
          .split(" ")
          .join("-")
      : "league";

    let eventSlug = event.eventName
      ? event.eventName
          .toLowerCase()
          .replace(/[^a-z0-9]/g, " ")
          .replace(/ +/g, " ")
          .trim()
          .split(" ")
          .join("-")
      : "";

    dispatch(
      setEventType({
        id: event?.sportId,
        name: SportNameByIdMap[event?.sportId],
        slug: SportSlugById[event?.sportId],
      })
    );
    dispatch(
      setCompetition({
        id: event?.competitionId,
        name: event?.competitionName,
        slug: competitionSlug,
      })
    );
    dispatch(
      setExchEvent({
        id: event?.eventId,
        name: event?.eventName,
        slug: eventSlug,
      })
    );

    setShowOpenBets(false);
    //   toggleAccountOptionsSidebar();

    navigate(
      `/exchange_sports/${
        SportNameByIdMap[event?.sportId]
      }/${competitionSlug}/${eventSlug}/${btoa(
        `BetFair:${event?.sportId}:${event?.competitionId}:${event?.eventId}`
      )}`
    );
  };

  const ReportsClient = new ReportingClient(
    getEnvUrlsMap(import.meta.env.VITE_NODE_ENV),
    sessionStorage.getItem("jwt_token"),
    errorHandler
  );

  const getExpData = async () => {
    dispatch(setLoading(true));
    let res = await ReportsClient.getExposureData();
    setExpData(res.data);
    if (res.data?.length > 0) {
      let sum = 0;
      for (let i = 0; i < res?.data?.length; i++) {
        sum += res?.data[i]?.exposure;
      }
      setTotalExp(sum);
    }
    dispatch(setLoading(false));
  };

  useEffect(() => {
    getExpData();
  }, []);

  return loading ? (
    <div className="flex justify-center my-5">
      <div className="w-5 h-5 border-2 border-gray-600 border-t-transparent rounded-full animate-spin"></div>
    </div>
  ) : expData?.length > 0 ? (
    <div className="overflow-x-auto">
      <table className="w-full text-xs md:text-sm border-collapse border border-gray-300 bg-white text-left text-gray-700">
        {/* Table Head */}
        <thead className="bg-gray-200">
          <tr className="border-b border-gray-300">
            <th className="px-4 py-2">{langData?.["event_type"]}</th>
            <th className="px-4 py-2">{langData?.["event_name"]}</th>
            <th className="px-4 py-2">{langData?.["expose"]}</th>
          </tr>
        </thead>

        {/* Table Body */}
        <tbody>
          {expData?.map((row, index) => (
            <tr
              key={index}
              className="border-b border-gray-300 hover:bg-gray-100"
            >
              <td className="px-4 py-2 capitalize">
                {SportNameByIdMap[row?.sportId]}
              </td>
              <td className="px-2 py-2">
                <button
                  className=" text-blue-600 underline rounded-md hover:bg-blue-100"
                  onClick={() => handleEventChange(row)}
                >
                  {row?.eventName}
                </button>
              </td>
              <td className="px-2 py-2">{row?.exposure}</td>
            </tr>
          ))}
          {exposure && totalExp && exposure !== totalExp ? (
            <tr className="border-t border-gray-300 bg-gray-100">
              <td className="px-4 py-2">{langData?.["others"]}</td>
              <td className="px-4 py-2"></td>
              <td className="px-4 py-2 font-semibold text-red-600">
                {-(Number(exposure) + Number(totalExp))?.toFixed(2)}
              </td>
            </tr>
          ) : null}
        </tbody>
      </table>
    </div>
  ) : (
    <div className="flex items-center justify-center text-[14px] text-[#757575] bg-neutral-200 h-full pt-7 pb-6 ">
      {langData?.["place_bet_to_see_it_here"]}
    </div>
  );
};

export default AllOpenBets;
